// src/pages/ServicesPage.jsx
import React from "react";
import { Link, Element } from "react-scroll";
import "./ServicesPage.scss";

import img1 from '../../../assets/Structure Cabling/Amp-1.jpg'
import img2 from '../../../assets/Structure Cabling/molex.jpg'
import img3 from '../../../assets/Structure Cabling/Commscope.png'

// server
import img4 from '../../../assets/Servers/IBM.jpg'
import img5 from '../../../assets/Servers/cisco.jpg'
import img6 from '../../../assets/Servers/dell.jpg'
import img7 from '../../../assets/Servers/hp.jpg'

// Switches
import img8 from '../../../assets/Switch/cisco.jpg'
import img9 from '../../../assets/Switch/dell.jpg'
import img10 from '../../../assets/Surveillance/dlink1.png'
import img11 from '../../../assets/Switch/aruba.png'
import img12 from '../../../assets/Switch/juniper.jpg'
import img13 from '../../../assets/Switch/netgear.jpg'
import img14 from '../../../assets/Switch/tp-link.jpg'
import img15 from '../../../assets/Switch/zyxel-1.jpg'

// Server
import img16 from '../../../assets/Servers/IBM.jpg'
import img17 from '../../../assets/Servers/cisco.jpg'
import img18 from '../../../assets/Servers/dell.jpg'
import img19 from '../../../assets/Servers/hpe1.png'

// Wireless Access Point
import img20 from '../../../assets/Switch/aruba.png'
import img21 from '../../../assets/Wireless Access Point/cisco.jpg'
import img22 from '../../../assets/Surveillance/dlink1.png'
import img23 from '../../../assets/Wireless Access Point/juniper.jpg'
import img24 from '../../../assets/Wireless Access Point/netgear.jpg'
import img25 from '../../../assets/Switch/tp-link.jpg'

// Surveillance
import img26 from '../../../assets/Surveillance/cp-plus.jpg'
import img27 from '../../../assets/Surveillance/essl.jpg'
import img28 from '../../../assets/Surveillance/dlink1.png'
import img29 from '../../../assets/Surveillance/hik-vision.jpg'
import img30 from '../../../assets/Surveillance/honeywell.jpg'
import img31 from '../../../assets/Surveillance/secureye.jpg'



export default function ServicesPage() {
  return (
    <div className="services-page">
      {/* Top sticky nav for sections */}
      <nav className="services-nav">
        <span>Services:</span>
        <Link to="structured-cabling" smooth={true} duration={500} offset={-80}>
          Structured Cabling
        </Link>
        <Link to="switches" smooth={true} duration={500} offset={-80}>
          Switches
        </Link>
        <Link to="servers" smooth={true} duration={500} offset={-80}>
          Servers
        </Link>
        <Link to="wireless-ap" smooth={true} duration={500} offset={-80}>
          Wireless Access Point
        </Link>
        <Link to="surveillance" smooth={true} duration={500} offset={-80}>
          Surveillance
        </Link>
      </nav>

      <main className="services-content">
        {/* ===== Structured Cabling ===== */}
        <Element name="structured-cabling" className="service-section">
          <h2>Structured Cabling</h2>

          <h3>Products Offered</h3>
          <ul className="tag-list">
            <li>D-Link</li>
            <li>Molex</li>
            <li>Comscope</li>
          </ul>
          <ul className="img-list">
            <li><img src={img10} alt="" /></li>
            <li><img src={img2} alt="" /></li>
            <li><img src={img3} alt="" /></li>
          </ul>

          <p>
            A structured cabling system is a complete system of cabling and
            associated hardware, which provides a comprehensive
            telecommunications infrastructure. This infrastructure serves a wide
            range of uses, such as providing telephone service or transmitting
            data through a computer network.
          </p>

          <p>Every structured cabling system is unique. This is due to:</p>
          <ul>
            <li>The architectural structure of the building;</li>
            <li>The cable and connection products;</li>
            <li>The function of the cabling installation;</li>
            <li>
              The types of equipment the cabling will support — present and
              future;
            </li>
            <li>The configuration of an existing system (upgrades / retrofits);</li>
            <li>Customer requirements; and</li>
            <li>Manufacturer warranties.</li>
          </ul>

          <p>
            National and international telecommunications cabling standards are
            used to design acceptable infrastructure cabling to provide
            networking. Structured cabling defines a generic telecommunication
            wiring system for commercial buildings and includes cabling,
            connectors, and accessories used to connect LAN and telephone system
            equipment.
          </p>

          <h3>We help you with:</h3>
          <ul className="bullet-grid">
            <li>Consultation</li>
            <li>Site Survey</li>
            <li>Design</li>
            <li>Implementation</li>
            <li>Testing &amp; Commissioning</li>
            <li>Documentation</li>
            <li>Maintenance &amp; Support Services</li>
          </ul>
        </Element>

        {/* ===== Switches ===== */}
        <Element name="switches" className="service-section">
          <h2> Switches</h2>

          <h3>Products Offered</h3>
          <ul className="tag-list">
            <li>Cisco</li>
            {/* <li>Juniper</li> */}
            <li>D-Link</li>
            <li>Netgear</li>
            <li>Dell</li>
            <li>TP-Link</li>
            <li>Aruba</li>
            {/* <li>Zyxel</li> */}
          </ul>

          <ul className="img-list">
            {/* <li><img src={img4} alt="" /></li>
            <li><img src={img5} alt="" /></li>
            <li><img src={img6} alt="" /></li> */}
            {/* <li><img src={img7} alt="" /></li> */}
            <li><img src={img8} alt="" /></li>
            <li><img src={img9} alt="" /></li>
            <li><img src={img10} alt="" /></li>
            <li><img src={img11} alt="" /></li>
            {/* <li><img src={img12} alt="" /></li> */}
            <li><img src={img13} alt="" /></li>
            <li><img src={img14} alt="" /></li>
            {/* <li><img src={img15} alt="" /></li>  */}
          </ul>

          <p>
            A switch is a device in a computer network that electrically and
            logically connects other devices. Multiple data cables are plugged
            into a switch to enable communication between different networked
            devices.
          </p>
          <p>
            Switches manage the flow of data across a network by transmitting a
            received network packet only to the device(s) for which the packet
            is intended. Each networked device connected to a switch can be
            identified by its network address, allowing the switch to regulate
            traffic, maximize efficiency, and improve security.
          </p>
        </Element>

        {/* ===== Servers ===== */}
        <Element name="servers" className="service-section">
          <h2>Servers</h2>

          <h3>Products Offered</h3>
          <ul className="tag-list">
            <li>Cisco</li>
            {/* <li>HP</li> */}
            <li>Dell</li>
            <li>HPE</li>
          </ul>

          <ul className="img-list">
            {/* <li><img src={img16} alt="" /></li> */}
            <li><img src={img17} alt="" /></li>
            <li><img src={img18} alt="" /></li>
            <li><img src={img19} alt="" /></li>
          </ul>

          <p>
            A server is a computer program or device that provides functionality
            for other programs or devices, called “clients”.
          </p>
          <p>
            Servers can provide various functionalities, often called “services”,
            such as sharing data or resources among multiple clients, or
            performing computation. A single server can serve multiple clients,
            and a single client can use multiple servers. Typical servers
            include database, file, mail, print, web, game, and application
            servers.
          </p>
        </Element>

        {/* ===== Wireless AP ===== */}
        <Element name="wireless-ap" className="service-section">
          <h2>Wireless Access Point</h2>

          <h3>Products Offered</h3>
          <ul className="tag-list">
            <li>Cisco</li>
            <li>Ruckus</li>
            <li>D-Link</li>
            {/* <li>Juniper</li> */}
            <li>Netgear</li>
            <li>Aruba</li>
          </ul>

           <ul className="img-list">
            <li><img src={img20} alt="" /></li>
            <li><img src={img21} alt="" /></li>
            <li><img src={img22} alt="" /></li>
            {/* <li><img src={img23} alt="" /></li> */}
            <li><img src={img24} alt="" /></li>
            <li><img src={img25} alt="" /></li>
          </ul>

          <p>
            A wireless access point (WAP) transmits and receives information
            from wireless radio signals. It allows a business network or Wi-Fi
            hotspot to connect devices and share data easily without extensive
            cabling.
          </p>
          <p>
            WAPs use firmware, antennas, and radio transceivers to capture and
            distribute data, usually aided by a router when combined with a
            wired network. This gives wireless devices a single point of entry
            into the network.
          </p>
        </Element>

        {/* ===== Surveillance ===== */}
        <Element name="surveillance" className="service-section">
          <h2>Surveillance</h2>

          <h3>Products Offered</h3>
          <ul className="tag-list">
            <li>Hikvision</li>
            <li>CP Plus</li>
            <li>TP-Link</li>
            <li>Honeywell</li>
            <li>D-Link</li>
            {/* <li>HID</li> */}
            <li>Secureye</li>
          </ul>

          <ul className="img-list">
            <li><img src={img26} alt="" /></li>
            <li><img src={img28} alt="" /></li>
            <li><img src={img25} alt="" /></li>
            <li><img src={img29} alt="" /></li>
            <li><img src={img30} alt="" /></li>
            <li><img src={img31} alt="" /></li>
          </ul>

          <p>
            CCTV (Closed Circuit Television) is an electronic system that helps
            monitor behaviour, activities, or other changing information for the
            purpose of influencing, managing, directing, or protecting people.
          </p>
          <p>
            A biometric device is a security identification and authentication
            device that verifies identity using physiological or behavioural
            characteristics such as fingerprints, facial images, iris scans, or
            voice recognition.
          </p>
        </Element>
      </main>
    </div>
  );
}
